const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

function formatMoney(cents) {
  const format = window.CozySort?.moneyFormat || '${{amount}}';
  const value = (cents / 100).toFixed(2);
  const [whole, decimal] = value.split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => {
    switch (name) {
      case 'amount_no_decimals':
        return grouped;
      case 'amount_with_comma_separator':
        return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimal}`;
      case 'amount_no_decimals_with_comma_separator':
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      case 'amount_with_apostrophe_separator':
        return `${grouped}.${decimal}`;
      default:
        return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimal}`;
    }
  });
}

function toast(message, variant = '') {
  const stack = $('#toast-stack');
  if (!stack) return;
  const el = document.createElement('div');
  el.className = variant ? `toast toast--${variant}` : 'toast';
  el.textContent = message;
  stack.appendChild(el);
  setTimeout(() => el.remove(), 3600);
}

let scrollLocks = 0;

function lockScroll(locked) {
  scrollLocks = Math.max(0, scrollLocks + (locked ? 1 : -1));
  document.body.style.overflow = scrollLocks > 0 ? 'hidden' : '';
}

function trapFocus(container) {
  const focusable = $$(
    'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',
    container
  ).filter((el) => el.offsetParent !== null);
  if (!focusable.length) return () => {};

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const handler = (event) => {
    if (event.key !== 'Tab') return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  container.addEventListener('keydown', handler);
  first.focus();
  return () => container.removeEventListener('keydown', handler);
}

// Alles, was Escape schliessen soll, meldet sich hier an — sonst raeumt
// jeder Handler das Scroll-Lock der anderen mit weg.
const closeOnEscape = [];

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeOnEscape.forEach((close) => close());
});

const Cart = {
  updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
      setTimeout(() => el.classList.remove('is-bumped'), 400);
    });
  },

  render(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = $('cart-drawer', parsed);
    const current = $('cart-drawer');
    if (incoming && current) current.innerHTML = incoming.innerHTML;
    if (incoming) this.updateCount(Number(incoming.dataset.count || 0));
  },

  // Hinzufuegen und Aendern unterscheiden sich nur in der Route. Beide holen
  // die Seitenleiste gleich mit zurueck und werfen bei einem Fehler.
  async post(route, payload) {
    const response = await fetch(route, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections: 'cart-drawer' })
    });
    const body = await response.text();
    let data = {};
    try {
      data = body ? JSON.parse(body) : {};
    } catch (error) {
      if (!response.ok) throw new Error(window.CozySort.strings.error);
    }
    if (!response.ok) throw new Error(data.description || data.message || window.CozySort.strings.error);
    if (data.sections) this.render(data.sections['cart-drawer']);
    return data;
  },

  add(items) {
    return this.post(window.CozySort.routes.cartAdd, { items });
  },

  change(payload) {
    return this.post(window.CozySort.routes.cartChange, payload);
  },

  open() {
    const drawer = $('cart-drawer');
    if (drawer) drawer.open();
  }
};

class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]')) this.close();
    });
  }

  open() {
    if (this.classList.contains('is-open')) return;
    this.classList.add('is-open');
    lockScroll(true);
    this.releaseFocus = trapFocus(this);
  }

  close() {
    if (!this.classList.contains('is-open')) return;
    this.classList.remove('is-open');
    lockScroll(false);
    if (this.releaseFocus) this.releaseFocus();
  }
}
customElements.define('cart-drawer', CartDrawer);

closeOnEscape.push(() => {
  const drawer = $('cart-drawer');
  if (drawer) drawer.close();
});

$$('[data-cart-open]').forEach((button) => {
  button.addEventListener('click', (event) => {
    if (window.CozySort?.cartType !== 'drawer') return;
    event.preventDefault();
    Cart.open();
  });
});

// Die Seitenleiste rendert sich selbst neu. Die Warenkorbseite kann das
// nicht — dort muss die Seite fuer Zwischensumme und Versand neu laden.
async function updateLine(element, payload) {
  try {
    await Cart.change(payload);
    if (!element.closest('cart-drawer')) window.location.reload();
  } catch (error) {
    toast(error.message || window.CozySort.strings.error, 'error');
  }
}

document.addEventListener('click', (event) => {
  const remove = event.target.closest('[data-line-remove]');
  if (!remove) return;
  event.preventDefault();
  updateLine(remove, { line: Number(remove.dataset.lineRemove), quantity: 0 });
});

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-line-qty]');
  if (!input) return;
  updateLine(input, { line: Number(input.dataset.lineQty), quantity: Number(input.value) });
});

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = $('input', this);
    $$('button', this).forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(button.dataset.step);
        const min = Number(this.input.min || 0);
        const next = Math.max(min, Number(this.input.value) + step);
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}
customElements.define('quantity-input', QuantityInput);

class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse($('[type="application/json"]', this).textContent);
    this.form = document.getElementById(this.dataset.form);
    this.addEventListener('change', () => this.update());
    this.update();
  }

  get selectedOptions() {
    return $$('fieldset', this).map((fieldset) => {
      const checked = $('input:checked', fieldset);
      if (checked) return checked.value;
      const select = $('select', fieldset);
      return select ? select.value : null;
    });
  }

  update() {
    const options = this.selectedOptions;
    const variant = this.variants.find((candidate) =>
      candidate.options.every((option, index) => option === options[index])
    );

    $$('[data-option-value]', this).forEach((label) => {
      const value = label.dataset.optionValue;
      const index = Number(label.dataset.optionIndex);
      const probe = options.slice();
      probe[index] = value;
      const match = this.variants.find((candidate) =>
        candidate.options.every((option, i) => option === probe[i])
      );
      const input = document.getElementById(label.htmlFor);
      if (input) input.disabled = !match || !match.available;
    });

    $$('[data-selected-value]', this).forEach((el, index) => {
      el.textContent = options[index] || '';
    });

    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));

    if (!this.form) return;

    const idInput = $('[name="id"]', this.form);
    const button = $('[type="submit"]', this.form);
    const priceEl = $(`#${this.dataset.priceTarget}`);

    if (variant) {
      idInput.value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    if (button) {
      button.disabled = !variant || !variant.available;
      button.textContent = !variant
        ? window.CozySort.strings.unavailable
        : variant.available
          ? window.CozySort.strings.addToCart
          : window.CozySort.strings.soldOut;
    }

    if (priceEl && variant) {
      const onSale = variant.compare_at_price > variant.price;
      priceEl.className = onSale ? 'price price--on-sale' : 'price';
      priceEl.innerHTML = this.priceMarkup(variant);
    }
  }

  priceMarkup(variant) {
    const current = `<span class="price__current">${formatMoney(variant.price)}</span>`;
    if (variant.compare_at_price > variant.price) {
      return `${current}<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`;
    }
    return current;
  }
}
customElements.define('variant-picker', VariantPicker);

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = $('form', this);
    this.button = $('[type="submit"]', this);
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  async submit(event) {
    if (window.CozySort?.cartType !== 'drawer') return;
    event.preventDefault();

    const id = Number($('[name="id"]', this.form).value);
    const quantityInput = $('[name="quantity"]', this.form);
    const originalText = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = '…';

    try {
      await Cart.add([{ id, quantity: quantityInput ? Number(quantityInput.value) : 1 }]);
      Cart.open();
    } catch (error) {
      toast(error.message || window.CozySort.strings.error, 'error');
    } finally {
      this.button.disabled = false;
      this.button.textContent = originalText;
    }
  }
}
customElements.define('product-form', ProductForm);

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button) return;
  event.preventDefault();

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = '…';

  try {
    await Cart.add([{ id: Number(button.dataset.quickAdd), quantity: 1 }]);
    if (window.CozySort?.cartType === 'drawer') Cart.open();
    else toast(window.CozySort.strings.added);
  } catch (error) {
    toast(error.message || window.CozySort.strings.error, 'error');
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
});

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.onClick = (event) => {
      const thumb = event.target.closest('[data-media]');
      if (thumb) this.show(thumb.dataset.media);
    };
    this.addEventListener('click', this.onClick);

    this.onVariantChange = (event) => {
      const media = event.detail.variant?.featured_media;
      if (media) this.show(String(media.id));
    };
    document.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    document.removeEventListener('variant:change', this.onVariantChange);
  }

  show(id) {
    $$('[data-media-id]', this).forEach((media) => {
      media.hidden = media.dataset.mediaId !== id;
    });
    $$('[data-media]', this).forEach((thumb) => {
      thumb.setAttribute('aria-current', String(thumb.dataset.media === id));
    });
  }
}
customElements.define('product-gallery', ProductGallery);

// Der Setup-Konfigurator.
//
// Es gibt hier absichtlich kein Zustandsobjekt. Die angehakten Radios sind
// der Zustand — sie ueberleben das Zurueckblaettern, funktionieren ohne
// Skript und koennen nicht mit einer Kopie auseinanderlaufen. Alles, was
// diese Klasse tut, ist lesen, rechnen und anzeigen.
class SetupBuilder extends HTMLElement {
  connectedCallback() {
    this.list = $('[data-setup-list]', this);
    this.empty = $('[data-setup-empty]', this);
    this.totalRow = $('[data-setup-total-row]', this);
    this.totalValue = $('[data-setup-total]', this);
    this.button = $('[data-setup-add]', this);
    this.addLabel = this.button ? this.button.textContent.trim() : '';

    // Ohne Zusammenfassung gibt es nichts zu rechnen.
    if (!this.list || !this.totalValue) return;

    this.addEventListener('change', (event) => {
      // Wer eine Farbe anklickt, meint das Modul. Ohne diese Zeile bliebe
      // die Karte ungewaehlt und die Farbwahl waere folgenlos.
      if (event.target.closest('.setup-opt__colors')) {
        const module = this.moduleInput(event.target.closest('.setup-opt'));
        if (module && !module.disabled) module.checked = true;
      }
      this.writeHash();
      this.update();
    });
    if (this.button) this.button.addEventListener('click', () => this.submit());

    // Auch fuer geteilte Links und fuer den Fall, dass jemand die Adresse
    // von Hand aendert.
    this.onHashChange = () => this.update(this.readHash());
    window.addEventListener('hashchange', this.onHashChange);

    this.update(this.readHash());
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this.onHashChange);
  }

  // Das Modul-Radio ist das direkte Kind der Karte. Der Kindbezug ist
  // Pflicht: in der Karte steckt eine zweite Radiogruppe fuer die Farbe,
  // deren erster Wert immer vorbelegt ist. Dieselbe Unterscheidung macht
  // :has(> input:checked) im CSS.
  moduleInput(card) {
    return $(':scope > input', card);
  }

  get steps() {
    return $$('[data-setup-step]', this);
  }

  // Was gerade gewaehlt ist, frisch aus dem DOM gelesen.
  get chosen() {
    return this.steps
      .map((step) => {
        const card = $$('.setup-opt', step).find((el) => this.moduleInput(el)?.checked);
        if (!card) return null;

        const module = this.moduleInput(card);
        const colour = $('.setup-opt__colors input:checked', card);

        // Gibt es Farben, gilt die Farbe: nur sie kennt die Variante, die
        // wirklich in den Warenkorb soll, und deren Preis.
        const source = colour || module;

        return {
          step: step.dataset.setupStep,
          id: Number(source.dataset.variantId),
          price: Number(source.dataset.price),
          title: module.dataset.title,
          colour: colour?.nextElementSibling?.textContent.trim() || ''
        };
      })
      .filter(Boolean);
  }

  get missingRequired() {
    return this.steps.filter(
      (step) =>
        step.dataset.required === 'true' &&
        !$$('.setup-opt', step).some((el) => this.moduleInput(el)?.checked)
    );
  }

  // ---------- Adresse ----------

  // Schritt und Variante als Paar, damit ein Modul, das in zwei Kategorien
  // liegt, beim Wiederherstellen im richtigen Schritt landet.
  writeHash() {
    const value = this.chosen.map((item) => `${item.step}:${item.id}`).join(',');
    const hash = value ? `#setup=${value}` : '';

    // replaceState und nicht pushState: bei pushState braeuchte man nach
    // zwanzig Klicks zwanzig Mal Zurueck, um die Seite zu verlassen. Der
    // Zweck ist ein teilbarer Link, und der steht so immer aktuell in der
    // Adresszeile.
    history.replaceState(null, '', location.pathname + location.search + hash);
  }

  readHash() {
    const match = /#setup=([A-Za-z0-9_:,-]+)/.exec(location.hash);
    return match ? match[1].split(',') : null;
  }

  // Setzt die Radios so, wie die Adresse es verlangt. Alles Weitere ergibt
  // sich daraus von selbst — es gibt ja keinen zweiten Zustand.
  applyHash(pairs) {
    // Beim Wiederherstellen ist die Adresse die Wahrheit, keine Ergaenzung.
    // Ohne dieses Zuruecksetzen bliebe beim Zurueckblaettern stehen, was
    // erst spaeter dazugekommen ist — die Seite zeigte dann eine andere
    // Zusammenstellung als ihre eigene Adresse, und ein geteilter Link
    // haette beim Absender anders ausgesehen als beim Empfaenger.
    //
    // Nur die Modul-Radios werden geleert. Die Farbwahl darf stehen bleiben:
    // ohne gewaehltes Modul zaehlt sie ohnehin nicht, und nennt der Hash
    // eine Farbe, wird sie gleich unten wieder gesetzt.
    this.steps.forEach((step) =>
      $$('.setup-opt', step).forEach((card) => {
        const module = this.moduleInput(card);
        if (module) module.checked = false;
      })
    );

    pairs.forEach((pair) => {
      const [stepId, variantId] = pair.split(':');

      // Beide Werte landen gleich in einem Attributselektor. Sie stehen dort
      // in Anfuehrungszeichen, CSS.escape waere also falsch — das escaped
      // fuer Bezeichner und wuerde aus einer Zahl «\34 4112233» machen.
      // Richtig ist, den Inhalt zu pruefen statt zu verbiegen.
      if (!/^[A-Za-z0-9_-]+$/.test(stepId || '') || !/^\d+$/.test(variantId || '')) return;

      const step = $(`[data-setup-step="${stepId}"]`, this);
      if (!step) return;

      const inputs = $$(`input[data-variant-id="${variantId}"]`, step);
      if (!inputs.length) return;

      const card = inputs[0].closest('.setup-opt');
      const module = this.moduleInput(card);
      if (module && !module.disabled) module.checked = true;

      const colour = inputs.find((input) => input.closest('.setup-opt__colors'));
      if (colour && !colour.disabled) colour.checked = true;
    });
  }

  // ---------- Anzeige ----------

  update(pairs = null) {
    if (pairs) this.applyHash(pairs);

    const chosen = this.chosen;
    const total = chosen.reduce((sum, item) => sum + item.price, 0);

    // textContent statt innerHTML: Produkttitel und Farbnamen kommen aus dem
    // Shop, und die gehoeren nie als Markup in die Seite.
    this.list.replaceChildren(
      ...chosen.map((item) => {
        const row = document.createElement('li');
        const name = document.createElement('span');
        name.textContent = item.colour ? `${item.title} · ${item.colour}` : item.title;
        const price = document.createElement('span');
        price.textContent = formatMoney(item.price);
        row.append(name, price);
        return row;
      })
    );

    if (this.empty) this.empty.hidden = chosen.length > 0;
    if (this.totalRow) this.totalRow.hidden = chosen.length === 0;
    this.totalValue.textContent = formatMoney(total);

    if (this.button) {
      this.button.disabled = chosen.length === 0 || this.missingRequired.length > 0;
    }
  }

  // ---------- Warenkorb ----------

  async submit() {
    const chosen = this.chosen;
    if (!chosen.length) return;

    // Dieselbe Variante kann in zwei Schritten stehen. Zusammenzaehlen statt
    // zweimal senden — sonst legt Shopify zwei Zeilen an.
    const merged = new Map();
    chosen.forEach((item) => merged.set(item.id, (merged.get(item.id) || 0) + 1));
    const items = Array.from(merged, ([id, quantity]) => ({ id, quantity }));

    this.button.disabled = true;
    this.button.textContent = '…';

    try {
      await Cart.add(items);
      if (window.CozySort?.cartType === 'drawer') {
        Cart.open();
      } else {
        window.location.href = window.CozySort.routes.cart;
      }
    } catch (error) {
      toast(error.message || window.CozySort.strings.error, 'error');
    } finally {
      this.button.textContent = this.addLabel;
      this.update();
    }
  }
}
customElements.define('setup-builder', SetupBuilder);

const mobileMenu = $('#mobile-menu');
if (mobileMenu) {
  const openMenu = () => {
    if (mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.add('is-open');
    lockScroll(true);
    mobileMenu.releaseFocus = trapFocus(mobileMenu);
  };
  const closeMenu = () => {
    if (!mobileMenu.classList.contains('is-open')) return;
    mobileMenu.classList.remove('is-open');
    lockScroll(false);
    if (mobileMenu.releaseFocus) mobileMenu.releaseFocus();
  };

  $$('[data-menu-open]').forEach((el) => el.addEventListener('click', openMenu));
  mobileMenu.addEventListener('click', (event) => {
    if (event.target.closest('[data-menu-close]')) closeMenu();
  });
  closeOnEscape.push(closeMenu);
}

const searchModal = $('#search-modal');
if (searchModal) {
  const input = $('input[name="q"]', searchModal);
  const results = $('#search-results', searchModal);
  let controller;

  const openSearch = () => {
    if (searchModal.classList.contains('is-open')) return;
    searchModal.classList.add('is-open');
    lockScroll(true);
    input.focus();
  };
  const closeSearch = () => {
    if (!searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    lockScroll(false);
  };

  $$('[data-search-open]').forEach((el) => el.addEventListener('click', openSearch));
  searchModal.addEventListener('click', (event) => {
    if (event.target === searchModal || event.target.closest('[data-search-close]')) closeSearch();
  });
  closeOnEscape.push(closeSearch);

  // Ohne Adresse ist die Sofortsuche abgeschaltet: Modal und Formular bleiben,
  // aber beim Tippen wird nichts nachgeladen.
  const liveSearch = window.CozySort.routes.predictiveSearch;
  if (liveSearch) {
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = input.value.trim();
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }

      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();
        const url = `${liveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search`;

        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error(window.CozySort.strings.error);
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const list = $('#predictive-results', parsed);
          results.innerHTML = list ? list.innerHTML : '';
        } catch (error) {
          if (error.name !== 'AbortError') {
            results.innerHTML = '';
            toast(error.message || window.CozySort.strings.error, 'error');
          }
        }
      }, 200);
    });
  }
}

// Die Sprach- und Landauswahl sendet ohne JavaScript ab; das hier schliesst
// die offene Liste nur beim Klick daneben oder mit Escape.
document.addEventListener('click', (event) => {
  $$('[data-loc-menu][open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

closeOnEscape.push(() => {
  $$('[data-loc-menu][open]').forEach((menu) => {
    menu.open = false;
  });
});

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  },
  { rootMargin: '0px 0px -6% 0px' }
);

const watchReveals = (root = document) => $$('.reveal:not(.is-visible)', root).forEach((el) => observer.observe(el));
watchReveals();
document.addEventListener('shopify:section:load', (event) => watchReveals(event.target));
